import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { ReasonCancelBooking, ReasonCancelBookingQueryParams } from "../types";

interface ReasonCancelBookingState {
	reasonCancelBookingList: Array<ReasonCancelBooking>;
	reasonCancelBookingDetail: ReasonCancelBooking;
	reasonCancelBookingTotal: number;
}

export const initialState: ReasonCancelBookingState = {
	reasonCancelBookingList: [],
	reasonCancelBookingDetail: {
		id: 0,
		reason: "",
		type: "",
	},
	reasonCancelBookingTotal: 0,
};

export const reasonCancelBookingSlice = createSlice({
	name: "reasonCancelBooking",
	initialState,
	reducers: {
		setListReasonCancelBooking: (state, action) => {
			state.reasonCancelBookingList = action.payload.data;
			state.reasonCancelBookingTotal = action.payload.total;
		},
		setDetailReasonCancelBooking: (state, action) => {
			state.reasonCancelBookingDetail = action.payload.data;
		},
	},
});

export const selectReasonCancelBookingList = (state: RootState) =>
	state.reasonCancelBooking.reasonCancelBookingList;
export const selectReasonCancelBookingTotal = (state: RootState) =>
	state.reasonCancelBooking.reasonCancelBookingTotal;
export const selectReasonCancelBookingDetail = (state: RootState) =>
	state.reasonCancelBooking.reasonCancelBookingDetail;
export const { setListReasonCancelBooking, setDetailReasonCancelBooking } =
	reasonCancelBookingSlice.actions;

export interface GetListReasonCancelBookingAsyncPayload {
	query: ReasonCancelBookingQueryParams;
}

export const getListReasonCancelBookingAsync = createAction(
	"reasonCancelBooking",
	(payload: GetListReasonCancelBookingAsyncPayload) => ({
		payload,
	}),
);

export default reasonCancelBookingSlice.reducer;
